//#region Libraries
import Dialog  from '@mui/material/Dialog'; 
import styled from "styled-components";
//#endregion

export const Container = styled(Dialog)`
    & .MuiPaper-root {
        padding: 10px !important;
        width: ${({ width = "max-content" }) => width};
        @media (min-width: 501px) {
            min-width: 400px !important;
            max-width: 70% !important;
        }
        @media (max-width: 500px) {
            width: 85% !important;
        }
        overflow: visible;
        border-radius: 8px;
    }
`;